import "@arco-design/web-react/es/Spin/style";
import _Spin from "@arco-design/web-react/es/Spin";
import "@arco-design/web-react/es/Steps/style";
import _Steps from "@arco-design/web-react/es/Steps";
import "@arco-design/web-react/es/Alert/style";
import _Alert from "@arco-design/web-react/es/Alert";
import _IconCheckCircle from "@arco-design/web-react/icon/react-icon/IconCheckCircle";
import _IconClockCircle from "@arco-design/web-react/icon/react-icon/IconClockCircle";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import "@arco-design/web-react/es/Tooltip/style";
import _Tooltip from "@arco-design/web-react/es/Tooltip";
import "@arco-design/web-react/es/Image/style";
import _Image from "@arco-design/web-react/es/Image";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React, { useEffect, useState } from 'react';
import Step from '@arco-design/web-react/es/Steps/step';
import dayjs from 'dayjs';
import { getTaskHistory } from '@/services';
import { useRequest } from 'ahooks';
import { ReleaseIcon, TaskCompletedIcon } from '../Icons';
import { getUserSignatureUrl } from '@/utils/signature';
const TASK_STATUS_MAP = {
  pending: {
    text: '待办',
    color: '#f7ba1e'
  },
  approved: {
    text: '已通过',
    color: '#00b42a'
  },
  rejected: {
    text: '已驳回',
    color: '#f53f3f'
  },
  returned: {
    text: '已退回',
    color: '#ff7d00'
  }
};
function formatFlowDateTime(value) {
  if (!value) return '';
  const m = dayjs(value);
  if (!m.isValid()) return '';
  const now = dayjs();
  if (m.year() !== now.year()) return m.format('YYYY-MM-DD');
  return m.format('MM-DD HH:mm');
}
function ProcessApprovalRecord({
  id
}) {
  const [traces, setTraces] = useState([]);
  const {
    run,
    loading
  } = useRequest(getTaskHistory, {
    manual: true,
    onSuccess: response => {
      setTraces(response.reverse());
    }
  });
  useEffect(() => {
    if (id) {
      run(id);
    }
  }, [id, run]);
  function AlertContent(item) {
    if (item.status === 'pending') {
      item.comment = '待办';
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "allow-wrap"
    }, item.comment || '-'), /*#__PURE__*/React.createElement("div", null, item.status !== 'pending' && /*#__PURE__*/React.createElement(_Image, {
      className: "lx-user-signature",
      src: getUserSignatureUrl(item.assigneeId),
      width: 56,
      height: 24
    }), /*#__PURE__*/React.createElement(_Button, {
      type: "text"
    }, /*#__PURE__*/React.createElement(_Tooltip, {
      content: "\u4EFB\u52A1\u5230\u8FBE\u65E5\u671F"
    }, /*#__PURE__*/React.createElement(ReleaseIcon, {
      style: {
        color: '#1677ff'
      }
    }), /*#__PURE__*/React.createElement("span", {
      className: "lx-flow-date ml-2"
    }, formatFlowDateTime(item.createDate)))), item.handledAt && /*#__PURE__*/React.createElement(_Button, {
      className: "ml20 !px-0",
      type: "text"
    }, /*#__PURE__*/React.createElement(_Tooltip, {
      content: "\u4EFB\u52A1\u5B8C\u6210\u65E5\u671F"
    }, /*#__PURE__*/React.createElement(TaskCompletedIcon, {
      style: {
        fontSize: 16,
        color: '#87d068'
      }
    }), /*#__PURE__*/React.createElement("span", {
      className: "lx-flow-date ml-2"
    }, formatFlowDateTime(item.handledAt))))));
  }
  return /*#__PURE__*/React.createElement(_Spin, {
    loading: loading,
    className: "lx-spin-history"
  }, /*#__PURE__*/React.createElement(_Steps, {
    className: "lx-steps-history",
    direction: "vertical"
  }, traces.map(item => {
    return /*#__PURE__*/React.createElement(Step, {
      className: `lx-step-item lx-item-${item.status}`,
      key: item.id,
      icon: item.status === 'pending' ? /*#__PURE__*/React.createElement(_IconClockCircle, null) : /*#__PURE__*/React.createElement(_IconCheckCircle, null),
      title: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, item.nodeName), /*#__PURE__*/React.createElement("div", {
        className: "lx-title-item"
      }, /*#__PURE__*/React.createElement("span", null, "\u5904\u7406\u4EBA"), /*#__PURE__*/React.createElement("span", null, item.assigneeName)), /*#__PURE__*/React.createElement("div", {
        className: "lx-title-item"
      }, /*#__PURE__*/React.createElement("span", null, "\u90E8\u95E8"), /*#__PURE__*/React.createElement("span", null, item.assigneeDeptName)), /*#__PURE__*/React.createElement("div", {
        className: "lx-title-item"
      }, /*#__PURE__*/React.createElement("span", null, "\u72B6\u6001"), /*#__PURE__*/React.createElement("span", null, TASK_STATUS_MAP[item.status]?.text))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_Alert, {
        showIcon: false,
        type: "info",
        content: AlertContent(item)
      })))
      // description={item.comment}
    });
  })));
}
export { ProcessApprovalRecord };